import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.app.modal_alert,
    (alert) => {
        return {
            alert
        }
    }
)